import { ListingSellerModel } from '@steelbuy/ts-shared';

import { createEntityDataContext } from '../../util/provider/EntityDataProvider';

export const ListingSellerEntityData = createEntityDataContext<ListingSellerModel>();
